import { render, staticRenderFns } from "./otp-input.vue?vue&type=template&id=d1958342&scoped=true&"
import script from "./otp-input.vue?vue&type=script&lang=js&"
export * from "./otp-input.vue?vue&type=script&lang=js&"
import style0 from "./otp-input.vue?vue&type=style&index=0&id=d1958342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1958342",
  null
  
)

export default component.exports